import * as Sentry from '@sentry/react'

interface ReactRouteErrorContext {
  boundary: string
  path: string
}

export default function captureReactRouteError(error: unknown, context: ReactRouteErrorContext) {
  Sentry.withScope(scope => {
    scope.setTag('react_error_boundary', context.boundary)
    scope.setContext('react_route_error', {
      path: context.path,
    })

    if (error instanceof Error) {
      Sentry.captureException(error)
      return
    }

    Sentry.captureException(new Error('Unexpected React route error'), {
      extra: {
        routeError: error,
      },
    })
  })
}
